/* Orca Running theme — storefront behaviour
   Mobile nav, cart drawer, AJAX add-to-cart, variant picker, quantity steppers. */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = (window.Orca && window.Orca.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withComma = parts.join('.');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0]);
  };

  /* ---------------------------------------------------------------- Mobile nav */
  var burger = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ------------------------------------------------------------- Cart drawer */
  var drawer = document.querySelector('[data-cart-drawer]');
  var backdrop = document.querySelector('[data-cart-backdrop]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    if (backdrop) backdrop.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (backdrop) backdrop.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart().then(openDrawer); }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-backdrop]')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ------------------------------------------------------------- Cart state */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('on', n > 0);
    });
  }

  function renderDrawer(cart) {
    var body = document.querySelector('[data-drawer-body]');
    var foot = document.querySelector('[data-drawer-total]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty mt-2"><h2>Your cart is empty</h2><p>Nothing in here yet.</p></div>';
      if (foot) foot.textContent = money(0);
      return;
    }
    body.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" loading="lazy">'
        : '';
      var opts = item.options_with_values && item.options_with_values.length
        ? '<div class="cart-line-opts">' + item.options_with_values.map(function (o) { return o.value; }).join(' / ') + '</div>'
        : '';
      return '<div class="cart-line" data-key="' + item.key + '">' +
        '<div class="cart-line-img">' + img + '</div>' +
        '<div><div class="cart-line-title">' + item.product_title + '</div>' + opts +
        '<div class="qty mt-1" data-qty>' +
          '<button type="button" data-qty-down aria-label="Decrease">&minus;</button>' +
          '<input type="number" min="0" value="' + item.quantity + '" data-line-qty aria-label="Quantity">' +
          '<button type="button" data-qty-up aria-label="Increase">+</button>' +
        '</div></div>' +
        '<div class="cart-line-right"><strong>' + money(item.final_line_price) + '</strong>' +
        '<button type="button" class="cart-line-remove" data-line-remove>Remove</button></div>' +
        '</div>';
    }).join('');
    if (foot) foot.textContent = money(cart.total_price);
  }

  function refreshCart() {
    return fetch(window.Routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); renderDrawer(cart); return cart; })
      .catch(function () { return null; });
  }

  function changeLine(key, quantity) {
    return fetch(window.Routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        renderDrawer(cart);
        if (document.body.classList.contains('template-cart')) window.location.reload();
        return cart;
      });
  }

  /* Drawer + cart page line controls */
  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-qty-up]');
    var down = e.target.closest('[data-qty-down]');
    var remove = e.target.closest('[data-line-remove]');

    if (up || down) {
      var wrap = (up || down).closest('[data-qty]');
      var input = wrap.querySelector('input');
      var next = Math.max(parseInt(input.min || 0, 10), (parseInt(input.value, 10) || 0) + (up ? 1 : -1));
      input.value = next;
      var line = wrap.closest('[data-key]');
      if (line) changeLine(line.dataset.key, next);
    }

    if (remove) {
      var l = remove.closest('[data-key]');
      if (l) changeLine(l.dataset.key, 0);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    var line = input.closest('[data-key]');
    if (line) changeLine(line.dataset.key, parseInt(input.value, 10) || 0);
  });

  /* ------------------------------------------------------------- Add to cart */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-btn]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Adding…'; }

    fetch(window.Routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = label; }
        var err = form.querySelector('[data-add-error]');
        if (!res.ok) {
          if (err) { err.textContent = res.data.description || res.data.message || 'Could not add to cart.'; err.classList.remove('hide'); }
          return;
        }
        if (err) err.classList.add('hide');
        return refreshCart().then(openDrawer);
      })
      .catch(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = label; }
        form.submit();
      });
  });

  /* --------------------------------------------------------- Variant picker */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var data = JSON.parse(picker.querySelector('[data-variant-json]').textContent);
    var form = document.querySelector('[data-add-form]');
    var idInput = form && form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var btn = form && form.querySelector('[data-add-btn]');

    function selected() {
      return Array.prototype.map.call(picker.querySelectorAll('[data-option-group]'), function (group) {
        var chosen = group.querySelector('[aria-checked="true"]') || group.querySelector('select');
        return chosen ? (chosen.dataset.value !== undefined ? chosen.dataset.value : chosen.value) : null;
      });
    }

    function update() {
      var vals = selected();
      var match = data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === vals[i]; });
      })[0];

      if (!match) {
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) {
        priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
          ? '<span class="price-sale">' + money(match.price) + '</span><span class="price-was">' + money(match.compare_at_price) + '</span>'
          : money(match.price);
      }
      if (btn) {
        if (match.available) {
          btn.removeAttribute('aria-disabled');
          btn.textContent = picker.dataset.addLabel || 'Add to cart';
        } else {
          btn.setAttribute('aria-disabled', 'true');
          btn.textContent = 'Sold out';
        }
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }

    picker.addEventListener('click', function (e) {
      var swatch = e.target.closest('.opt-swatch');
      if (!swatch) return;
      swatch.closest('[data-option-group]').querySelectorAll('.opt-swatch')
        .forEach(function (s) { s.setAttribute('aria-checked', 'false'); });
      swatch.setAttribute('aria-checked', 'true');
      update();
    });
    picker.addEventListener('change', function (e) { if (e.target.matches('select')) update(); });
  });

  /* ------------------------------------------------------------ PDP gallery */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('.pdp-thumb');
      if (!thumb) return;
      var main = gallery.querySelector('[data-gallery-main]');
      if (main) { main.src = thumb.dataset.full; main.alt = thumb.dataset.alt || ''; }
      gallery.querySelectorAll('.pdp-thumb').forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
      thumb.setAttribute('aria-selected', 'true');
    });
  }

  /* Standalone quantity steppers (PDP) */
  document.querySelectorAll('[data-qty]:not([data-key] [data-qty])').forEach(function () {});

  refreshCart();
})();
